@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.illustration {
  --speed: 1;
}

.illustration :global(.hand-black) {
  transform-box: fill-box;
  transform-origin: 50% 115%;
  animation: rotate calc(60s / var(--speed)) steps(60, end) infinite;
}

.illustration :global(.hand-red) {
  rotate: 174deg;
  transform-box: fill-box;
  transform-origin: 50% 115%;
  animation: rotate calc(3600s / var(--speed)) steps(60, end) infinite;
}
